const PROJECT_FIELD_MAP = [
  { key: "name", matchers: ["name", "title"] },
  { key: "description", matchers: ["description", "desc"] },
  { key: "status", matchers: ["status"] },
  { key: "tags", matchers: ["tags"] },
  { key: "accessMap", matchers: ["accessmap", "publicaccesspolicy", "roleaccesslist", "userroles", "userrolemap"] },
  { key: "customData", matchers: ["customdata"] },
];

const normalizePathPart = (value) => String(value || "").trim().toLowerCase();

const mapChangeEntryToField = (entry) => {
  const fieldName = normalizePathPart(entry?.fieldName);
  const subFieldName = normalizePathPart(entry?.subFieldname);
  const path = [fieldName, subFieldName].filter(Boolean).join(".");

  if (!path) return null;

  const mapped = PROJECT_FIELD_MAP.find((candidate) =>
    candidate.matchers.some((matcher) => path.includes(matcher))
  );

  return mapped?.key || null;
};

const extractChangedFields = (changes) => {
  if (!Array.isArray(changes) || changes.length === 0) return [];

  const fields = changes
    .map(mapChangeEntryToField)
    .filter(Boolean);

  return Array.from(new Set(fields));
};

export const parseProjectSsePayload = (payload) => {
  if (!payload || typeof payload !== "object") {
    return null;
  }

  // New backend contract: { fullRecord, changes[] }.
  if (payload.fullRecord && payload.fullRecord.id) {
    return {
      backendProject: payload.fullRecord,
      changedFields: extractChangedFields(payload.changes),
      rawChanges: Array.isArray(payload.changes) ? payload.changes : [],
    };
  }

  // Legacy/full object fallback.
  if (payload.id) {
    return {
      backendProject: payload,
      changedFields: [],
      rawChanges: [],
    };
  }

  return null;
};
